/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-string-refs */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/no-unused-state */
import './index.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  mergeProps,
  MyIcon,
  NormalObj,
} from '../../../util';
import { ResourceType } from '../types';
/**
 * 初始化状态-initialState
 *
 * @result visible 下载框显示
 * @result percent 下载框百分比
 * @result title 下载框课件名字
 * @result isError 下载框报错
 * @result childCourseWare 作业资料附属课件
 *
 */
const initialState = {
  visible: false,
  percent: 0,
  title: null,
  isError: false,
  childCourseWare: null,
};
/**
 * 点播播放页-AttachmentItem课件组件
 *
 * @props data 课件数据
 * @props type  课件格式 1-word, 2-ppt, 3-image, 4-audio, 5-video, 6-gif, 7-excel, 8-pdf, 9-zip, 10-ocrf, 其他(非空)-other
 * @props name 课件名称
 * @props active 激活样式标志
 * @props preview 课件预览
 * @props extension 课件后缀名
 * @props resourceId 资源中心id
 * @props activeIndex 选中序号
 * @props attachmentId 主键ID
 *
 */
interface P {
  data: NormalObj;
  index: number;
  active?: any;
  type?: any;
  name?: any;
  preview?: any;
  extension?: any;
  resourceId?: any;
  activeIndex?: any;
  attachmentId?: any;
  onClick: () => void;
  isVideo?: boolean;
  functionConfig: NormalObj;
}
class ResourceAttachmentItem extends Component<P, any> {
  constructor(props: P) {
    super(props);
    this.state = {
      data: this.props.data,
      type: this.props.type,
      name: this.props.name,
      active: this.props.active,
      preview: this.props.preview,
      extension: this.props.extension,
      resourceId: this.props.resourceId,
      activeIndex: this.props.activeIndex,
      attachmentId: this.props.attachmentId,
      ...initialState,
    };
    // this.type = this.props.type;
  }
  componentWillReceiveProps(nextProps: P) {
    this.setState({ ...nextProps });
  }

  /**
   * 关闭下载框
   */
  handleCancel = () => {
    const { percent, isError } = this.state;
    if (percent < 100 && !isError) return;
    this.setState({ percent: 0, visible: false });
  };
  /**
   * 课件对应ICON
   */
  getType() {
    const o = {
      name: '',
      type: '',
    };
    const { data, isVideo } = this.props;
    if (isVideo) {
      o.type = 'iconFile_mp';
      // switch (data.extension.toLowerCase()) {
      //   case 'mp4':
      //     o.type = 'iconFile_mp';
      //     break;
      //   case 'crf':
      //   case 'crf2':
      //   case 'ocrf':
      //     o.type = 'iconocrf';
      //     break;
      //   case 'txt':
      //     o.type = 'iconFile_txt';
      //     break;
      //   default:
      //     o.type = 'iconunknown';
      //     break;
      // }
    } else {
      switch (data.resourceType.code) {
        case ResourceType.PREPARE_LESSON_MEMOIR:
        case ResourceType.PREPARE_LESSON_WARE:
        case ResourceType.MODEL_COURSE:
        case ResourceType.COURSE_WARE:
        case ResourceType.COURSE_MEMOIR:
          o.name = '课件';
          o.type = 'iconcourseware';
          break;
        case ResourceType.MATERIAL:
          o.name = '素材';
          o.type = 'iconmaterial';
          break;
        case ResourceType.GENERAL_ASSIGNMENT:
        case ResourceType.GENERAL_PREVIEW:
        case ResourceType.DOCUMENT_PAPER:
          o.name = '普通作业';
          o.type = 'iconoperation';
          break;
        case ResourceType.GENERAL_PAPER:
          o.name = '普通试卷';
          o.type = 'icontest_paper';
          break;
        default:
          o.name = '未知';
          o.type = 'iconunknown';
          break;
      }
    }

    return o;
  }

  /**
   * 转化name和extension
   *
   * @params data 课件
   * @params type 作业资料附属课件
   *
   */
  getNameExtension(data: any, type: any) {
    let name = '';
    let extension = '';
    if (!data) return { name: '', extension: '' };
    if (type === 'childList') {
      name = data.fileName;
      extension = data.fileExtension;
    } else {
      name = data.fileName;
      extension = data.extension;
    }
    return { name, extension };
  }
  /**
   * 转化课件名
   *
   * @params name 课件名字
   * @params extension 课件后缀名
   *
   */
  getFileName(name: any, extension: any) {
    if (extension) {
      if (name.includes(`.${extension}`)) {
        return name;
      } else {
        return `${name}.${extension.toLocaleLowerCase()}`;
      }
    }
    return name;
  }

  render() {
    const {
      active,
      data,
      index,
      // is_create,
      isVideo,
      // functionConfig: { downloadFile = false },
    } = this.props;
    // const { visible, percent, isError } = this.state;
    return (
      <div
        ref="component"
        onClick={this.props.onClick}
        className={`attachment-item ${active === data.fileId + index ? 'active' : ''} ${
          data.expiryState ? 'expire-item' : ''
        }`}
      >
        <MyIcon className="iconfont expire-icon" type="iconziyuan" />
        <div className="attachment-item-inner">
          <div className="attachment-item-inner-logo">
            <MyIcon className="iconfont" type={this.getType().type} />
          </div>
          <div
            style={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: !data.downloadState ? 'row' : 'column',
            }}
            title={isVideo ? data.fileName.slice(0, -4) : data.fileName}
          >
            <div className="attachment-item-inner-name">
              {isVideo ? data.fileName.slice(0, -4) : data.fileName}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  functionConfig: { ...state.DynamicControl.functionConfig },
});

export default connect(mapStateToProps, mergeProps)(ResourceAttachmentItem);
